<template>
  <div class="configNetPage">
    <!-- 第一部分: 基础信息 -->
    <div class="section-box">
      <ConfigBase
        :row-data="rowData"
        :net-params="netParams"
        :coordinator="coordinator"
      ></ConfigBase>
    </div>
    <!-- 第二部分: 配置参数 -->
    <div class="section-box" v-loading="loading">
      <el-form
        ref="form"
        :model="dioForm"
        :rules="rules"
        label-position="right"
        label-width="auto"
        label-suffix="："
      >
        <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.extPanId"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                netParams.status !== 2 &&
                  dioForm['extPanIdCurrent'] &&
                  dioForm['extPanIdCurrent'].change
              "
              >{{ dioForm['extPanIdCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['extPanIdCurrent']" style="color: red">
              {{ dioForm['extPanIdCurrent'].modify }}
            </span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('Join Attemp')" prop="channelPage">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.channelPage"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                netParams.status !== 2 &&
                  dioForm['channelPageCurrent'] &&
                  dioForm['channelPageCurrent'].change
              "
              >{{ dioForm['channelPageCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['channelPage']" style="color: red">
              {{ dioForm['channelPageCurrent'].modify }}
            </span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.channelMask"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                netParams.status !== 2 &&
                  dioForm['channelMaskCurrent'] &&
                  dioForm['channelMaskCurrent'].change
              "
              >{{ dioForm['channelMaskCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['channelMaskCurrent']" style="color: red">
              {{ dioForm['channelMaskCurrent'].modify }}
            </span>
          </template>
        </el-form-item>
      </el-form>
      <div class="form-actions" v-if="rowData['configStatus'] !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn"
          >{{ $t('public.config') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn"
            >{{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" @click="configSave"
            >{{ $t('public.save') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command (只有存在16进制命令时才显示) -->
    <div class="section-box" v-if="baseContent.cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ baseContent.cmd }}</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 第四部分: 配置列表 -->
    <div class="section-box" v-if="listArray.length">
      <div class="list">
        <div class="listPage" v-for="item in listArray" :key="item.id">
          <span>{{ $timetransition(item['logTime']) }}</span>
          <!-- 只能输网络参数 -->
          <span>{{ $t('integration.network_parameters') }}</span>
          <span>{{ configFn(item['stepCode']) }}</span>
          <el-button
            type="text"
            size="small"
            :title="$t('public.details')"
            icon="el-icon-tickets"
            @click="configDetailFn(item)"
          ></el-button>
        </div>
      </div>
    </div>
    <!-- 命令详情 -->
    <CmdDialog
      :title="title"
      :isShow.sync="isShow"
      v-bind="$attrs"
      :cmdObj="cmdObj"
    />
  </div>
</template>

<script>
import { gatewayUpdateNetConfig, getNetConfig } from '@/api/modules/gateway.js'
import { getConfigLogContent } from '@/api/modules/deviceUrl.js'
import addRules from '@/pages/equipment/validate/addRules.js'
import {
  configStatusConvert,
  configStep,
  gatewayTypeConvert
} from '@/utils/convert'
import ConfigBase from '@/pages/equipment/gateway/modal/ConfigDialog/ConfigBase.vue'
import CmdDialog from '@/pages/equipment/gateway/components/CmdDialog.vue'
import { transformMultiCarrier } from '@/utils/transform/carrierTransform'

export default {
  // 行数据 以及是否属于网关协调器
  props: {
    rowData: {},
    coordinator: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ConfigBase,
    CmdDialog
  },
  computed: {
    rules () {
      const rules = addRules.call(this, 'rule', [
        'extPanId',
        'channelPage',
        'channelMask',
        'transmitPower',
        'inNetInterval'
      ])
      return rules
    }
  },
  data () {
    return {
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.gateway_name',
          key: 'name'
        },
        {
          text: 'Mac',
          key: 'mac'
        },
        {
          text: 'device.config_status',
          key: 'config_status'
        },

        {
          text: 'public.carrier',
          key: 'carrierName'
        },
        {
          text: 'public.type',
          key: 'type'
        }
      ],
      baseContent: {},
      dioForm: {
        extPanId: null,
        channelPage: null,
        channelMask: null
      },
      listArray: [],
      isClickConfig: true,
      // 详情
      isShow: false,
      title: '',
      cmdObj: {},
      loading: false,
      netParams: {}
    }
  },
  activated () {
    if (this.$attrs.sensorWay !== 'bind' && this.$attrs.sensorWay !== 'stop') {
      this.baseMsg.splice(-2, 1)
    }
    this.httpUrlFn()
  },
  methods: {
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },
    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async configSave () {
      const flag = await this.justify()
      if (!flag) return
      this.loading = true
      const { extPanId, channelPage, channelMask } = this.dioForm
      const query = {
        extPanId: extPanId,
        channelPage: channelPage,
        channelMask: channelMask,
        idList: [this.rowData.id]
      }
      gatewayUpdateNetConfig(query)
        .then(({ result, state }) => {
          if (result && state.code === 200) {
            this.$message.success($t('integration.update_successful'))
            this.httpUrlFn()
            this.isClickConfig = !this.isClickConfig
          } else {
            this.$message.error(state.msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    httpUrlFn () {
      getNetConfig({ gatewayId: this.rowData.id })
        .then(({ result }) => {
          if (result) {
            this.netParams = result

            if (result.content) {
              const JsonContent = JSON.parse(result.content)
              this.baseContent.cmd = JsonContent.cmd
              this.dioForm = {
                extPanId: JsonContent.item.ext_pan_id.modify,
                extPanIdCurrent: JsonContent.item.ext_pan_id,
                channelPage: JsonContent.item.channel_page.modify,
                channelPageCurrent: JsonContent.item.channel_page,
                channelMask: JsonContent.item.channel_mask.modify,
                channelMaskCurrent: JsonContent.item.channel_mask
              }
            }
            this.listArray = result.responseDeviceConfigLogList
          } else {
            // 默认值
            this.dioForm = {}
          }
        })
        .catch(() => {
          this.dioForm = {}
        })
    },
    changeTextFn (key, value) {
      if (key === 'type') {
        return this.$t(gatewayTypeConvert(value).title)
      } else {
        return this.$t(configStatusConvert(value).title)
      }
    },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    configDetailFn (row) {
      this.isShow = true
      this.title = `[${
        row.deviceName
      }][${$t('integration.network_parameters')}] ${$t('integration.configuration_details')}-[${this.$timetransition(row.logTime)}]`

      getConfigLogContent({ configLogId: row.id }, 'gateway').then(
        ({ result }) => {
          if (result.content) {
            const JsonContent = JSON.parse(JSON.parse(result.content).content)
            let url = this.rowData.scopeName
            if (this.rowData.sceneName) {
              url += '/' + this.rowData.sceneName
            }
            if (this.rowData.carrierName) {
              url += '/' + this.rowData.carrierName
            }
            this.cmdObj = {
              url: url,
              name: this.rowData.name,
              mac: this.rowData.mac,
              config_status: this.netParams.status,
              carrierName: transformMultiCarrier(this.rowData.carrierName)
                .map(item => item.name)
                .join(','),
              type: this.rowData.type,

              step: result.stepCode,
              cmd: JsonContent.cmd,
              ...JsonContent.item
            }
          }
        }
      )
      // let JsonContent = '';
      // if (row.content) {
      //     JsonContent = JSON.parse(row.content)||{}
      // }
      // const JSONCONTENT = JSON.parse(JsonContent.content);
      // const { cmd, item } = JSONCONTENT;
      // this.cmdObj = Object.assign({}, this.rowData, {
      //     cmd,
      //     channelMask: item['channelMask'],
      //     channelPage: item['channelPage'],
      //     extPanId: item['extPanId'],
      //     step: row['step_code']
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;
    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cmd-text {
    word-break: break-all;
    font-family: Consolas, Monaco, monospace;
    color: #303133;
  }
}
</style>
